import React from 'react'
import { useDispatch } from 'react-redux'
import { Dialog, Button, Box } from '@material-ui/core'
import {
  setIsOpenImportProgressDialog,
  useImportExternalSourceData,
} from 'app/store/importExternalSource'
import { FormattedMessage } from 'react-intl'
import { setCancelImportDialog } from 'app/store/importCSV'
import themesConfig from 'app/fuse-configs/themesConfig'

import CircularProgressWithLabel from '../../LoadingProgress/CircularProgressWithLabel'
import {
  CANCEL_SIS_IMPORT,
  SCHOOL_IMPORT_STATUS_CANSEL,
} from '../../constansts'

import useStyles from './styles'

const DialogImport = () => {
  const dispatch = useDispatch()
  const { isOpenImportProgressDialog, checkImportData } =
    useImportExternalSourceData()
  const classes = useStyles()
  const { importStatus } = checkImportData

  const onClose = () => {
    dispatch(setIsOpenImportProgressDialog(false))
  }

  const handleCancelImport = () => {
    dispatch(setCancelImportDialog(CANCEL_SIS_IMPORT))
  }

  const isCancellationProcess = importStatus === SCHOOL_IMPORT_STATUS_CANSEL

  return (
    <Dialog
      className={classes.dialogWrap}
      open={isOpenImportProgressDialog}
      onClose={onClose}
    >
      <Box
        display={'flex'}
        flexDirection={'column'}
        justifyContent={'center'}
        alignItems={'center'}
        sx={{ gap: 12 }}
      >
        <CircularProgressWithLabel size={40} value={0} />
        <Box
          component={'p'}
          color={themesConfig.default.colors['neutrals-600']}
          fontSize={18}
          lineHeight={'24px'}
          fontWeight={500}
          textAlign={'center'}
        >
          <FormattedMessage
            id={
              isCancellationProcess
                ? 'subscribers.import.progressBar.text8'
                : 'subscribers.import.progressBar.text3'
            }
          />
        </Box>
        <Box
          component={'p'}
          color={themesConfig.default.colors['neutrals-600']}
          fontSize={14}
          lineHeight={'20px'}
          textAlign={'center'}
        >
          <FormattedMessage id="subscribers.import.progressBar.text2" />
        </Box>
        {!isCancellationProcess ? (
          <Button
            color="secondary"
            className={classes.cancelImportBtn}
            onClick={handleCancelImport}
          >
            <FormattedMessage id="subscribers.importExternalSource.importProgressDialog.cancelImportBtn.label" />
          </Button>
        ) : null}
      </Box>
    </Dialog>
  )
}

export default DialogImport
